import React from "react"
import { SlideUpModal } from "./content/slide-up-modal"
import Shield from "../images/shield-sky-medium.svg"

type AvobEntryFormInfoProps = {
    isOpen: boolean
    onOpenChange: (isOpen: boolean) => void
    avobDisplayName?: string
}

const AvobEntryFormInfoModal = ({
    isOpen,
    onOpenChange,
    avobDisplayName
}: AvobEntryFormInfoProps) => {
    return (<SlideUpModal
        isOpen={isOpen}
        onOpenChange={() => onOpenChange(false)}
        autoFocusCloseButton={true}
    >
        <img src={Shield} alt='A sky-blue shield Icon' />
        <h2 className="in-network-modal-header">
            {`You're in-network! Let's match you with the right provider.`}
        </h2>
        <p className="in-network-modal-paragraph">
            {
                avobDisplayName
                    ? (`This estimate is based on what other ${avobDisplayName} patients typically pay per session. We'll verify your exact benefits and send it to you before your first appointment.`)
                    : (`This estimate is based on what Rula patients typically pay per session using insurance. We'll verify your exact benefits and send it to you before your first appointment.`)
            }
        </p>
    </SlideUpModal>)
}

export default AvobEntryFormInfoModal